
import { Component, Watch, Mixins } from 'vue-property-decorator';
import { primaryCurrency, reasonsForExport } from '@/features/common/raw';
import { UserPreferences } from '@/features/settings/types';
import { patchPreferences } from '@/features/settings/services/preferences.services';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { CurrencyCodeType } from '@/features/shipment/types';
import { PreferencesMixin } from './mixins';

@Component
export default class CustomsSettings extends Mixins(PreferencesMixin, ResponsivenessMixin) {
  private reasonForExport = reasonsForExport;

  private currencies: Array<keyof typeof CurrencyCodeType> = primaryCurrency;

  private formCustomSettings = {
    reasonForExport: '',
    currencyCode: 'USD',
  }

  private showSettingsAlert = {
    success: false,
    show: false,
  };

  get isUserPreferences(): number {
    return this.$store.getters.getIsUserPreferences;
  }

  get userPreferences(): UserPreferences {
    return this.$store.getters.getUserPreferences;
  }

  @Watch('isUserPreferences', { immediate: true })
  private populatePreferences(newValue: number) {
    if (!newValue) return;
    if (!this.userPreferences.customsSettings) return;

    const { reasonForExport, currencyCode } = this.userPreferences.customsSettings;

    this.formCustomSettings.reasonForExport = reasonForExport || '';
    this.formCustomSettings.currencyCode = currencyCode || 'USD';
  }

  private async updateSettingsPreference({ path, value }: {
    path: string,
    value: unknown,
  }) {
    this.patchPreferenceInStore(`customsSettings/${path}`, value);

    const response = await patchPreferences(this.userPreferences.id, [
      {
        path: `customsSettings/${path}`,
        op: 'replace',
        value,
      },
    ]);

    this.showSettingsAlert = {
      show: true,
      success: !!response,
    };
  }
}
